import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';

// Logo pré-importé pour éviter les problèmes de chargement retardé
import logoFile from '../assets/logo-genius-white.png';

// Version simplifiée sans mémoration excessive et structure allégée pour chargement rapide
export function Footer() {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  
  // Structure simplifiée pour un rendu plus rapide
  return (
    <footer className="bg-[#0D3C4C] text-white py-10 print:hidden">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo et description - Chargement prioritaire */}
          <div>
            <div className="h-16 w-[150px] mb-3">
              <img 
                src={logoFile} 
                alt="Genius Vente Logo"
                width={120} 
                height={50}
                className="h-full w-auto object-contain" 
                fetchPriority="high"
              />
            </div>
            <p className="text-gray-400">
              {t.footer.description}
            </p>
          </div>
          
          {/* Section Produit */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.footer.product}</h4>
            <ul className="space-y-2">
              <li><button className="text-gray-400 hover:text-white transition-colors">{t.footer.features}</button></li>
              <li><button className="text-gray-400 hover:text-white transition-colors">{t.footer.pricing}</button></li>
              <li><button className="text-gray-400 hover:text-white transition-colors">{t.footer.download}</button></li>
            </ul>
          </div>
          
          {/* Section Support */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.footer.support}</h4>
            <ul className="space-y-2">
              <li><button className="text-gray-400 hover:text-white transition-colors">{t.footer.documentation}</button></li>
              <li><button className="text-gray-400 hover:text-white transition-colors">{t.footer.contact}</button></li>
              <li><button className="text-gray-400 hover:text-white transition-colors">{t.footer.faq}</button></li>
            </ul>
          </div>
          
          {/* Section Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.footer.legal}</h4>
            <ul className="space-y-2">
              <li>
                <button
                  className="text-gray-400 hover:text-white transition-colors"
                  onClick={() => navigate(`/${language}/privacy-policy`)}
                >
                  {t.footer.privacyPolicy}
                </button>
              </li>
              <li><button className="text-gray-400 hover:text-white transition-colors">{t.footer.termsOfService}</button></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-4 border-t border-gray-800 text-center text-gray-400">
          <p>© {currentYear} Genius Vente. {t.footer.allRightsReserved}</p>
        </div>
      </div>
    </footer>
  );
}